module.exports = __webpack_public_path__ + "562fdd90cee5b55259371225ffa3677c.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/aircraft-take-off.svg
 ** module id = 528
 ** module chunks = 0
 **/